import React from 'react';

const MultiSelectStep = ({ question, value = [], onAnswer, onNext }) => {
  const selectedValues = Array.isArray(value) ? value : [];

  // Check if an option is a "none" type option (mutually exclusive)
  const isNoneOption = (optionValue) => {
    const noneValues = ['none', 'none-of-the-above', 'no'];
    return noneValues.includes(optionValue?.toLowerCase?.() || optionValue);
  };

  const toggleOption = (optionValue) => {
    const isNone = isNoneOption(optionValue);
    
    if (selectedValues.includes(optionValue)) {
      // Deselecting an option
      onAnswer(selectedValues.filter(v => v !== optionValue));
    } else {
      // Selecting an option
      if (isNone) {
        // If selecting "none", clear all other selections and only select "none"
        onAnswer([optionValue]);
      } else {
        // If selecting any other option, remove any "none" options and add this one
        const filteredValues = selectedValues.filter(v => !isNoneOption(v));
        onAnswer([...filteredValues, optionValue]);
      }
    }
  };

  const hasSelection = selectedValues.length > 0;

  return (
    <div data-testid={`step-${question.id}`}>
      {/* Question */}
      <h2 className="text-2xl md:text-3xl font-semibold text-center text-gray-900 mb-2">
        {question.question}
      </h2>

      {/* Subtitle */}
      <p className="text-center text-gray-500 mb-8">
        {question.subtitle || 'Select all that apply'}
      </p>

      {/* Options */}
      <div className="space-y-3 mb-8">
        {question.options.map((option, index) => {
          const optionValue = option.value || option;
          const isSelected = selectedValues.includes(optionValue);
          const isNone = isNoneOption(optionValue);
          
          return (
            <button
              key={index}
              onClick={() => toggleOption(optionValue)}
              className={`checkbox-card w-full p-5 rounded-xl text-left transition-all ${
                isSelected ? 'selected' : ''
              }`}
              data-testid={`option-${index}`}
            >
              <div className="flex items-center gap-4">
                {/* Checkbox */}
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-all flex-shrink-0 ${
                  isSelected ? 'bg-[#2d8a5f] border-[#2d8a5f]' : 'border-gray-300'
                }`}>
                  {isSelected && (
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  )}
                </div>
                <span className={`text-base font-medium ${isNone ? 'text-gray-600' : 'text-gray-800'}`}>
                  {option.label || option}
                </span>
              </div>
            </button>
          );
        })}
      </div>

      {/* Continue Button */}
      <button
        onClick={onNext}
        disabled={!hasSelection}
        className="btn-primary"
        data-testid="continue-button"
      >
        Continue
      </button>
    </div>
  );
};

export default MultiSelectStep;
